import Dexie from 'dexie';
import type { DatabaseSyncSnapshot, EntitySyncSnapshot } from 'shared/domain/serviceData/entitySync';
import db from './index';

const SERVICE_TABLE_SUFFIX = 'Service';

async function readEntitySyncSnapshot(serviceTableName: string, entityTableName: string): Promise<EntitySyncSnapshot> {
  const entityTable = db.tables.find(({ name }) => name === entityTableName);
  const [serviceData, rowCount] = await Promise.all([
    db.table(serviceTableName).toCollection().last(),
    entityTable ? entityTable.count() : null,
  ]);
  return { serviceData: serviceData ?? null, rowCount };
}

/**
 * The last row of every `<entity>Service` table and the rows of its entity
 * table, keyed by entity. Read outside any running transaction (it is called
 * by logs of failed ones); a table that cannot be read shows as never synced.
 */
export function readServiceTablesSnapshot(): Promise<DatabaseSyncSnapshot> {
  return Dexie.ignoreTransaction(async () => {
    const serviceTableNames = db.tables.map(({ name }) => name).filter((name) => name.endsWith(SERVICE_TABLE_SUFFIX));
    const entries = await Promise.all(
      serviceTableNames.map(async (serviceTableName): Promise<[string, EntitySyncSnapshot]> => {
        const entity = serviceTableName.slice(0, -SERVICE_TABLE_SUFFIX.length);
        const snapshot = await readEntitySyncSnapshot(serviceTableName, entity).catch(
          (): EntitySyncSnapshot => ({ serviceData: null, rowCount: null })
        );
        return [entity, snapshot];
      })
    );
    return Object.fromEntries(entries);
  });
}
